import { get, post, postList, postJson, patch, formatUrl, deleteMethod } from '../../../utils/request'
import {
  DETAIL_TALENT,
  LIST_CONNECTION_COMMENT,
  LIST_EDUCATION_TRAINING,
  LIST_WORKING_HISTORY,
  LIST_NOTICE_BOARD,
  LIST_PROUD_OF,
  LIST_WORKING_PORTFOLIO,
  LIST_EMPLOYMENT_HISTORY,
  DETAIL_EMPLOYER,
  LIST_CONNECTION_COMMENT_EMPLOYER,
  LIST_EDUCATION_TRAINING_EMPLOYER,
  LIST_HISTORY_EMPLOYER,
  LIST_NOTICE_BOARD_EMPLOYER,
  LIST_PROUD_OF_EMPLOYER,
  LIST_WORKING_PORTFOLIO_EMPLOYER,
  LIST_EMPLOYMENT_HISTORY_EMPLOYER,
  LIST_EMPLOYER,
  CREATE_PROFILE_EMPLOYER,
  UPDATE_PROFILE_EMPLOYER,
  DELETE_PROFILE_EMPLOYER,
  UPDATE_PROFILE_TALENT,
  UPDATE_PROUD_OF_EMPLOYER,
  UPDATE_PROUD_OF_TALENT,
  LIST_HISTORY_EMPLOYER_ADDED,
  UPDATE_HISTORY_EMPLOYER,
  LIST_HISTORY_TALENT_ADDED,
  UPDATE_HISTORY_TALENT,
  UPDATE_WORKING_PORTFOLIO_EMPLOYER,
  UPDATE_WORKING_PORTFOLIO_TALENT,
  UPDATE_EDUCATION_TRAINING_TALENT,
  UPDATE_EDUCATION_TRAINING_EMPLOYER,
  LIST_JOBS_TO_MAKE_OFFER,
  SYNC_DATA_FROM_USER_PROFILE,
  DOWNLOAD_CONTRACT,
  ACCEPT_CONTRACT,
  START_CALL,
  JOIN_CALL,
  ONLINE_OFFLINE_STATUS
} from '../../../utils/urls'

const actions = {
  createUserEmployer: async (context, payload) => {
    let url = formatUrl(CREATE_PROFILE_EMPLOYER, payload.params)
    return post(url, payload.params)
  },
  syncDataFromUserProfile: async (context, payload) => {
    const response = await post(SYNC_DATA_FROM_USER_PROFILE)
    return response
  },
  updateUserEmployer: async (context, payload) => {
    let url = formatUrl(UPDATE_PROFILE_EMPLOYER, payload.params)
    return patch(url, payload.params)
  },
  fetchBusinessAccount: async (context, payload) => {
    try {
      let response = await get(LIST_EMPLOYER)
      let status = response.status
      if (status === 200) {
        const { data } = response
        context.commit('setListBusinessAccount', data)
      }
    } catch (e) {
      context.commit('setListBusinessAccount', [])
    }
  },
  deleteBusinessAccount: (context, payload) => {
    let url = formatUrl(DELETE_PROFILE_EMPLOYER, payload.params)
    return deleteMethod(url, payload.params)
  },
  updateUserTalent: async (context, payload) => {
    let url = formatUrl(UPDATE_PROFILE_TALENT, payload.params)
    return patch(url, payload.params)
  },
  getEmployerInfoDetail: async (context, payload) => {
    try {
      let url = formatUrl(DETAIL_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        const { data } = response
        if (data.testimonial) {
          data.testimonial.forEach((t) => {
            t.user_post_job = t.talent_pick_job
            t.id = t.uuid
            delete t.uuid
            delete t.talent_pick_job
          })
        }
        context.commit('setEmployerInfoDetail', data)
      }
    } catch (e) {
      context.commit('setEmployerInfoDetail', [])
    }
  },
  getListConnectionCommentEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_CONNECTION_COMMENT_EMPLOYER, payload.params)
      let response = await get(url, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit(
          'setListConnectingCommentEmployer',
          response.data['results']
        )
      }
    } catch (e) {
      context.commit('setListConnectingCommentEmployer', [])
    }
  },
  getListEducationTrainingEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_EDUCATION_TRAINING_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit(
          'setListEducationTrainingEmployer',
          response.data['results']
        )
      }
    } catch (e) {
      context.commit('setListEducationTrainingEmployer', [])
    }
  },
  getListHistoryEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_HISTORY_EMPLOYER, payload.params)
      let response = await get(url, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setListHistoryEmployer', response.data['results'])
        context.commit('setTotalHistoryEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListHistoryEmployer', [])
      context.commit('setTotalHistoryEmployer', 0)
    }
  },
  getListEmploymentHistoryEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_EMPLOYMENT_HISTORY_EMPLOYER, payload.params)
      let response = await get(url, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit(
          'setListEmploymentHistoryEmployer',
          response.data['results']
        )
      }
    } catch (e) {
      context.commit('setListEmploymentHistoryEmployer', [])
    }
  },
  getListNoticeBoardEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_NOTICE_BOARD_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListNoticeBoardEmployer', response.data['results'])
      }
    } catch (e) {
      context.commit('setListNoticeBoardEmployer', [])
    }
  },
  getListProudOfEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_PROUD_OF_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListProudOfEmployer', response.data['results'])
      }
    } catch (e) {
      context.commit('setListProudOfEmployer', [])
    }
  },
  getListWorkingPortfolioEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_WORKING_PORTFOLIO_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit(
          'setListWorkingPortfolioEmployer',
          response.data['results']
        )
      }
    } catch (e) {
      context.commit('setListWorkingPortfolioEmployer', [])
    }
  },
  getTalentInfoDetail: async (context, payload) => {
    try {
      let url = formatUrl(DETAIL_TALENT, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setTalentDetail', response.data)
      }
    } catch (e) {
      context.commit('setTalentDetail', [])
    }
  },
  getListConnectionComment: async (context, payload) => {
    try {
      let url = formatUrl(LIST_CONNECTION_COMMENT, payload.params)
      let response = await get(url, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setListConnectingComment', response.data['results'])
      }
    } catch (e) {
      context.commit('setListConnectingComment', [])
    }
  },
  getListEducationTraining: async (context, payload) => {
    try {
      let url = formatUrl(LIST_EDUCATION_TRAINING, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListEducationTraining', response.data['results'])
      }
    } catch (e) {
      context.commit('setListEducationTraining', [])
    }
  },
  getListWorkingHistory: async (context, payload) => {
    try {
      let url = formatUrl(LIST_WORKING_HISTORY, payload.params)
      let response = await get(url, payload.query)
      let status = response.status
      if (status === 200) {
        context.commit('setListWorkingHistory', response.data['results'])
        context.commit('setTotalWorkingHistory', response.data['count'])
      }
    } catch (e) {
      context.commit('setListWorkingHistory', [])
      context.commit('setTotalWorkingHistory', 0)
    }
  },
  getContract: async (context, payload) => {
    try {
      let url = formatUrl(DOWNLOAD_CONTRACT, payload.params)
      let response = await get(url, payload.query)
      let status = response.status
      if (status === 200) {
        return response
      }
    } catch (e) {
      return e
    }
  },
  displayContract: async (context, payload) => {
    try {
      let url = formatUrl(ACCEPT_CONTRACT, payload.params)
      let response = await post(url, payload.params)
      let status = response.status
      if (status === 200) {
        return response
      }
    } catch (e) {
      throw e
    }
  },
  startCall: async (context, payload) => {
    try {
      let url = formatUrl(START_CALL, payload.params)
      let response = await post(url, payload.params)
      let status = response.status
      if (status === 200) {
        return response
      }
    } catch (e) {
      return e
    }
  },
  joinCall: async (context, payload) => {
    try {
      let url = formatUrl(JOIN_CALL, payload.params)
      let response = await post(url, payload.params)
      let status = response.status
      if (status === 200) {
        return response
      }
    } catch (e) {
      return e
    }
  },
  getListEmploymentHistory: async (context, payload) => {
    try {
      let url = formatUrl(LIST_EMPLOYMENT_HISTORY, payload.params)
      let response = await get(url, payload.params)
      let status = response.status
      if (status === 200) {
        context.commit('setListEmploymentHistory', response.data['results'])
      }
    } catch (e) {
      context.commit('setListEmploymentHistory', [])
    }
  },
  getListNoticeBoard: async (context, payload) => {
    try {
      let url = formatUrl(LIST_NOTICE_BOARD, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListNoticeBoard', response.data['results'])
      }
    } catch (e) {
      context.commit('setListNoticeBoard', [])
    }
  },
  getListProudOf: async (context, payload) => {
    try {
      let url = formatUrl(LIST_PROUD_OF, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListProudOf', response.data['results'])
      }
    } catch (e) {
      context.commit('setListProudOf', [])
    }
  },
  getListWorkingPortfolio: async (context, payload) => {
    try {
      let url = formatUrl(LIST_WORKING_PORTFOLIO, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListWorkingPortfolio', response.data['results'])
      }
    } catch (e) {
      context.commit('setListWorkingPortfolio', [])
    }
  },
  updateProudOfEmployer: async (context, payload) => {
    let url = formatUrl(UPDATE_PROUD_OF_EMPLOYER, payload.params)
    await postList(url, payload.params)
  },
  updateProudOfTalent: async (context, payload) => {
    let url = formatUrl(UPDATE_PROUD_OF_TALENT, payload.params)
    await postList(url, payload.params)
  },
  getListHistoryEmployerAdded: async (context, payload) => {
    try {
      let url = formatUrl(LIST_HISTORY_EMPLOYER_ADDED, payload.params)
      let response = await get(url, payload.query)
      let status = response.status
      if (status === 200) {
        context.commit('setListHistoryEmployerAdded', response.data['results'])
        context.commit('setTotalHistoryEmployerAdded', response.data['count'])
      }
    } catch (e) {
      context.commit('setListHistoryEmployerAdded', [])
      context.commit('setTotalHistoryEmployerAdded', 0)
    }
  },
  updateHistoryEmployer: async (context, payload) => {
    let url = formatUrl(UPDATE_HISTORY_EMPLOYER, payload.params)
    await postJson(url, payload.body)
  },
  getListHistoryTalentAdded: async (context, payload) => {
    try {
      let url = formatUrl(LIST_HISTORY_TALENT_ADDED, payload.params)
      let response = await get(url, payload.query)
      let status = response.status
      if (status === 200) {
        context.commit('setListHistoryTalentAdded', response.data['results'])
        context.commit('setTotalHistoryTalentAdded', response.data['count'])
      }
    } catch (e) {
      context.commit('setListHistoryTalentAdded', [])
      context.commit('setTotalHistoryTalentAdded', 0)
    }
  },
  updateHistoryTalent: async (context, payload) => {
    let url = formatUrl(UPDATE_HISTORY_TALENT, payload.params)
    await postJson(url, payload.body)
  },
  updateWorkportfolioTalent: async (context, payload) => {
    let url = formatUrl(UPDATE_WORKING_PORTFOLIO_TALENT, payload.params)
    return postList(url, payload.params)
  },
  updateWorkportfolioEmployer: async (context, payload) => {
    let url = formatUrl(UPDATE_WORKING_PORTFOLIO_EMPLOYER, payload.params)
    await postList(url, payload.params)
  },
  updateEducationTrainingTalent: async (context, payload) => {
    let url = formatUrl(UPDATE_EDUCATION_TRAINING_TALENT, payload.params)
    return postList(url, payload.params)
  },
  updateEducationTrainingEmployer: async (context, payload) => {
    let url = formatUrl(UPDATE_EDUCATION_TRAINING_EMPLOYER, payload.params)
    await postList(url, payload.params)
  },
  getListJobsToMakeOffer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_JOBS_TO_MAKE_OFFER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setListJobsToMakeOffer', response.data['results'])
      }
    } catch (e) {
      context.commit('setListJobsToMakeOffer', [])
    }
  },
  updateOnlineOfflineStatus: async (context, payload) => {
    try {
      let response = await post(ONLINE_OFFLINE_STATUS, payload)
      let status = response.status
      if (status === 200) {
        return response
      }
    } catch (error) {
    }
  }
}

export default actions
